import { render, staticRenderFns } from "./painting_details.vue?vue&type=template&id=0b63c84e&scoped=true&"
import script from "./painting_details.vue?vue&type=script&lang=js&"
export * from "./painting_details.vue?vue&type=script&lang=js&"
import style0 from "./painting_details.vue?vue&type=style&index=0&id=0b63c84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63c84e",
  null
  
)

export default component.exports